module.exports = __webpack_public_path__ + "img/zfcg_02.2c040d6c.png";